const DEFAULT_NUMBER_MASK_BLOCK_NAME = 'VALUE';
const DEFAULT_NUMBER_MASK_BLOCK = { mask: Number, thousandsSeparator: ' ' };

export const getChangeEvent = (event) => {
  let key;
  let value;

  const isObject = typeof event === 'object' && event;
  const isNativeEvent = isObject && 'target' in event;

  if (isNativeEvent) {
    value = event.target?.value;
  } else if (isObject) {
    const [[keyEntry, valueEntry]] = Object.entries(event);

    key = keyEntry;
    value = valueEntry;
  } else {
    value = event;
  }

  return { key, value };
};

export const getPlaneChangeEvent = (event) => {
  const { value } = getChangeEvent(event);

  return value;
};

export const transformFromNumberToString = (value) => {
  return typeof value === 'number' ? String(value) : '';
};

export const transformFromStringToNumber = (value) => {
  const result = Number(value);

  return Number.isFinite(result) ? result : 0;
};

export const generateNumberMask = ({ min = 1, postfix, scale = 0, ...rest }) => {
  return [
    { mask: '' },
    {
      blocks: {
        [DEFAULT_NUMBER_MASK_BLOCK_NAME]: { ...DEFAULT_NUMBER_MASK_BLOCK, min, scale, ...rest },
      },
      lazy: false,
      mask: [DEFAULT_NUMBER_MASK_BLOCK_NAME, postfix].filter(Boolean).join(' '),
    },
  ];
};
